// src/app/features/payments/checkout/components/sections/PayActionSection.tsx
import { motion } from "motion/react";
import { useNavigate } from "react-router-dom";
import type { CheckoutLocationState } from "@/app/core/TokensPayment/checkOutComp/subscribe/shared/checkoutTypes";
import { useTranslation } from "@/app/core/ui/theme/LanguageProvider";

interface PayActionSectionProps {
  product: CheckoutLocationState;
  appliedPromo: string | null;
  isTelegramStarsSelected: boolean;
  formattedTotal: string;
  isPriceReady: boolean;
}

export function PayActionSection({
  product,
  appliedPromo,
  isTelegramStarsSelected,
  formattedTotal,
  isPriceReady,
}: PayActionSectionProps) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleClick = () => {
    if (!isTelegramStarsSelected || !isPriceReady) return;
    navigate("/profile/payment/validation", {
      state: { ...product, promoCode: appliedPromo ?? undefined },
    });
  };

  return (
    <div style={{ paddingBottom: "calc(env(safe-area-inset-top) + 40px)" }}>
    <motion.button
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.5 }}
      whileTap={{ scale: 0.98 }}
      onClick={handleClick}
      disabled={!isTelegramStarsSelected || !isPriceReady}
      className="mt-6 flex w-full items-center justify-center gap-2 rounded-xl bg-violet-600 px-6 py-4 text-base font-bold text-white hover:bg-violet-700 disabled:cursor-not-allowed disabled:opacity-50"
      
    >
      <span>{t('pay')}</span>
      <span>{formattedTotal}</span>
    </motion.button>
    </div>
  );
}